
<template>

<el-row>
    <el-row>
        <el-form :inline="true" :model="queryParam" class="demo-form-inline">
            <el-form-item v-if="isAdmin">
                <channel-select  ref="channelSelect" clearable filterable  @change="channelIdsChange" placeholder="线索来源"></channel-select>
            </el-form-item>

            <el-form-item>
                <el-select v-model="queryParam.status" @change="search" clearable placeholder="线索质量">
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="有效" value="2"></el-option>
                    <el-option label="无效" value="3"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-date-picker v-model="queryParam.createTime" @change="search" type="daterange" start-placeholder="选择推荐起止范围" end-placeholder="选择推荐截止范围">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryParam.cluePersonPhone" placeholder="请输入手机号码" >
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadList()">搜索</el-button>
            <el-button type="warning" v-if="isAdmin" @click="exportExcel()">导出</el-button>
          </el-form-item>
        </el-form>
    </el-row>

    <el-row>
        <el-table :data="datas" border style="width: 100%"     tooltip-effect="dark">
            <el-table-column label="询价人">
                <template scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.cluePersonName }} </span>
                    <br>
                    <span style="margin-left: 10px">{{ scope.row.cluePersonPhone }}</span>
                </template>
            </el-table-column>

            <el-table-column label="询价车系">
                <template scope="scope">
                    <p> {{ scope.row.series }}</p>
                </template>
            </el-table-column>

            <el-table-column v-if="isAdmin" label="渠道来源">
                <template scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.channelName }}</span>
                </template>
            </el-table-column>

            <el-table-column label="线索质量">
                <template scope="scope">
                    <p> {{ scope.row.status | lcwStatusFilter}}</p>
                </template>
            </el-table-column>
            <el-table-column label="推荐时间">
                <template scope="scope">
                    <p class=" text-nowrap">{{ scope.row.createTime | dateTimeFormat}}</p>
                </template>
            </el-table-column>
            <el-table-column label="推荐人信息">
              <template scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.offerName }} </span>
                  <br>
                  <span style="margin-left: 10px">{{ scope.row.offerPhone }}</span>
                  <br>
                  <span style="margin-left: 10px">风险评测:{{ scope.row.offerBadFlag }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="isAdmin" label="操作" prop="note">
              <template scope="scope">
                  <p class=" text-nowrap">{{ scope.row.remark}} </p>

                  <el-button v-if="scope.row.status==1" @click="showAuditDialog(scope.row.id,2)" type="text">有效</el-button>
                  <el-button v-if="scope.row.status==1" @click="showAuditDialog(scope.row.id,3)" type="text">无效</el-button>

                  <el-button @click="editNote(scope.row.id)" type="text">{{scope.row.remark?'修改':'备注'}}</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-left:0px" class="row basic-margin" @size-change="fn" @current-change="fn" :current-page="currentPage" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-row>
</el-row>

</template>

<script>

import BasicPager from '../../mixins/BasicPager'
import ClueModel from '../../framework/models/clueModel'
import BusinessModel from '../../framework/models/businessModel'
import ChannelModel from '../../framework/models/channelModel'
import Config from '@/framework/configs/Config'
import channelSelect from '@/components/channelSelect'
export default {
  name: 'lcw-clue-management',
  extends: BasicPager,
  components: {
    channelSelect
  },
  data: function () {
    return {
      isAdmin: false,
      queryParam: {
        status: null,
        businessId: '',
        channelId: '',
        createTime: null,
        evaluateTime: null,
        lookTime: null,
        cluePersonPhone: null

      },
      note: null,
      datas: [],
      currentPage: 1,
      total: 0,
      loading: false
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
    this.loadList()
    this.initData()
  },
  methods: {
    channelIdsChange: function (channelId) {
      this.queryParam.channelId = channelId
      this.search()
    },
    exportExcel: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + 'clue/exportLcwClueExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath

      if (this.queryParam.status) {
        url += '&status=' + this.queryParam.status
      }
      if (this.queryParam.channelId) {
        url += '&channelId=' + this.queryParam.channelId
      }
      if (this.queryParam.cluePersonPhone) {
        url += '&cluePersonPhone=' + this.queryParam.cluePersonPhone
      }

      if (this.queryParam.createTime && this.queryParam.createTime[0]) {
        url += '&startTime=' + this.queryParam.createTime[0].getTime() + '&endTime=' + this.queryParam.createTime[1].getTime()
      }

      window.open(url)
    },
    showAuditDialog: function (id, status) {
      this.$confirm('请确认你的审核操作是否无误？', '线索审核后不能逆转，请二次确认！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auditStatus(id, status)
        this.loadList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消添加'
        })
      })
    },
    auditStatus: function (id, status) {
      let _this = this
      let params = {
        id: id,
        status: status
      }

      let listener = {
        success: function () {
          _this.$message({
            type: 'success',
            message: '操作成功！ '
          })
          _this.loadList()
        },
        error: function () {
          _this.$message({
            type: 'error',
            message: '操作失败！ '
          })
        }
      }

      ClueModel.changeStatus(this, params, listener)
    },
    editNote: function (clueId) {
      this.$prompt('请输入线索备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        if (!value) {
          this.$message({
            type: 'info',
            message: '备注不能为空！ '
          })

          return
        }

        let _this = this
        let params = {
          id: clueId,
          remark: value
        }

        let listener = {
          success: function () {
            _this.$message({
              type: 'success',
              message: '操作成功！ '
            })
            _this.loadList()
          },
          error: function () {
            _this.$message({
              type: 'error',
              message: '操作失败！ '
            })
          }
        }

        ClueModel.saveRemark(this, params, listener)
      })
    },
    fn: function (d) {
      this.currentPage = d
      this.loadList()
    },
    search: function () {
      this.currentPage = 1
      this.loadList()
    },
    loadList: function (pageNumber) {
      let _this = this
      // 如果为渠道商登陆 则设置查询渠道id为该渠道商
      if (_this.getLoginInfo().id) {
        _this.queryParam.channelId = _this.getLoginInfo().id
      }

      let params = {
        status: _this.queryParam.status,
        channelId: _this.queryParam.channelId,
        pageNum: _this.currentPage,
        cluePersonPhone: this.queryParam.cluePersonPhone,
        pageSize: 10
      }
      if (_this.queryParam.createTime && _this.queryParam.createTime.length == 2) {
        let startTime = _this.queryParam.createTime[0]
        let endTime = _this.queryParam.createTime[1]

        if (startTime) {
          params.startTime = startTime.getTime()
        }

        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      ClueModel.findLcwClue(_this, params, listener)
    }
  }
}

</script>
